function toggleEnabledClass(swiperInstance) {
    const sliderEl = swiperInstance.el;
    if (swiperInstance.enabled)
        sliderEl.classList.add("swiper-enabled");
    else
        sliderEl.classList.remove("swiper-enabled");
}

function initSwiper(element, options) {
    return new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
            // Move the Swiper buttons out of the usual wrapper as they need to be above the main slider content
            // and the default styles for Swiper have an overflow:hidden that hides them.
            nextEl: element.parentElement.querySelector('.swiper-button-next'),
            prevEl: element.parentElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: element.querySelector('.swiper-pagination') || '.swiper-pagination',
            clickable: true,
        },
        autoHeight: true,
        observer: true,
        observeParents: true,
        on: {
            init: function () {
                toggleEnabledClass(this);
            },
            resize: function () {
                toggleEnabledClass(this);
            }
        },
        ...options, // Merge with custom options
    });
}

function setupCarousels(selector, config = {}, alwaysEnabled = false) {
    document.querySelectorAll(selector).forEach(element => {
        const swiper = initSwiper(element, config);

        const prevButton = swiper.params.navigation.prevEl;
        const nextButton = swiper.params.navigation.nextEl;
        const swiperContainer = document.querySelector(selector);

        function checkButtons() {
            if (prevButton.classList.contains('swiper-button-disabled') &&
                nextButton.classList.contains('swiper-button-disabled')) {
                swiperContainer.parentElement.classList.add('swiper-fallback');
            } else {
                swiperContainer.parentElement.classList.remove('swiper-fallback');
            }
        }

        // Run the check initially and on slide change
        checkButtons();
        swiper.on('slideChange', checkButtons);

        if (!alwaysEnabled) {
            let lastState = window.innerWidth < 980; // Store the last state
            if (lastState)
                swiper.enable();
            else
                swiper.disable();

            window.addEventListener('resize', () => {
                const shouldEnable = window.innerWidth < 980;
                
                if (shouldEnable !== lastState) { // Only update when crossing the threshold
                    lastState = shouldEnable;
                    
                    if (shouldEnable)
                        swiper.enable();
                    else
                        swiper.disable();

                    swiper.update();

                    checkButtons();
                }
            });
        }
    });
}

// Desktop-only interpage links
function directionalCollectionLinks() {
    const element = document.querySelector('#interpage-links');
    if (element) {
        const swiper = initSwiper(element, {
            enabled: window.innerWidth < 980,
            breakpoints: {
                980: { enabled: false }
            }
        });

        window.addEventListener('resize', () => {
            swiper.params.enabled = window.innerWidth < 980;
            swiper.update();
        });

        window.addEventListener('load', () => swiper.update());
    }
}

// Initialise different types of carousels
function initCarousels() {
    setupCarousels('[data-carousel-type="image"]', { 
        enabled: true,
        slidesPerView: 1.5,
        spaceBetween: 25,
        breakpoints: {
            500: {
                slidesPerView: 3.5
            },
            980: {
                slidesPerView: 4.5
            },
            1200: {
                slidesPerView: 5.5
            }
        }
    }, true);
    setupCarousels('[data-carousel-type="text"]', {
        enabled: true,
        breakpoints: {
            980: {
                loop: false
            }
        }
    }, true);
    setupCarousels('[data-carousel-type="swatch"]', {
        enabled: true,
        spaceBetween: 0,
        breakpoints: {
            980: {
                loop: false
            }
        }
    }, false);
    setupCarousels('[data-carousel-type="product"]', { 
        enabled: true,
        breakpoints: {
            980: {
                loop: false
            }
        }
    }, true);
}

// Initialise everything
document.addEventListener('DOMContentLoaded', () => {
    directionalCollectionLinks();
    initCarousels();
});